/**
 * The quiet marker that a newer build is waiting.
 *
 * Deliberately not a control and not a dialog: an update arriving mid-level must not
 * interrupt play, steal focus, or break pointer lock. It states that an update is ready
 * and points at the pause menu, where the actual restart action lives — one thumb-sized
 * button in a place the player already knows, rather than a new tappable thing appearing
 * over the world while they are looking around.
 */

import { useGameStore } from '../store/gameStore';

export function UpdateNotice() {
  const isUpdateReady = useGameStore((store) => store.isUpdateReady);

  if (!isUpdateReady) return null;

  return (
    <div className="update-notice" role="status" aria-live="polite">
      Update ready — restart from the pause menu
    </div>
  );
}
